<template>
	<div class="content">
		<div v-if="datalist.length>0">
			<div class="listBox" v-for="item in datalist" :key="item.id">
				<a href="javascript:;" class="billBar">
					<van-row>
						<van-col span="24" class="cont">
							<van-col span="24" class="text address">{{item.address}}</van-col>
							<van-col span="24" class="text">{{item.reason}}</van-col>
							<van-col span="24" class="payBtn">
								<van-button round type="danger" class="solidBtn"
									@click.stop="handleClick(item.id)" v-if="item.evaluateStatus=='0'">去评价</van-button>
								<van-button round type="danger" disabled  class="hollowBtn" v-else>已评价</van-button>
							</van-col>
						</van-col>
					</van-row>
				</a>
			</div>
		</div>
		<van-row class="noPayBar" v-if="datalist.length == 0">
			<van-col span="24" class="noPayPC"></van-col>
			<van-col span="24" class="text1 orange">暂无可评价订单！</van-col>
		</van-row>
	</div>
</template>

<script>
	import {
		reqEvaluateList
	} from '../../api'
	export default {
		name: "order",
		data() {
			return {
				active: 0,
				datalist: [],
				userId:''
			}
		},
		created() {
			this.userId = this.$cookies.get('userInfo').userId
		},
		mounted() {
			this.getOrderList();
		},
		methods: {
			handleClick(val) {
				this.$router.push({
					path: '/evaluate',
					name: 'evaluate',
					query: {
						id: val
					}
				});
			},
			getOrderList() {
				this.datalist = []
				let params = {
					userId:this.userId
				}
				reqEvaluateList(params).then(res=>{
					if(res.success){
						this.datalist = res.data
					}
				})
			}
		},
	}
</script>
<style lang="stylus" rel="stylesheet/stylus">
	@import "../../common/stylus/mixins.styl"
</style>
<style scoped>
	.content{
		padding-top: 10px;
	}
	.listBox{
		background-color: #FFFFFF;
		padding: 15px;
		margin-bottom: 20px;
		
	}
	.listBox .text{
		font-size: 24px;
		line-height: 48px;
		height: 48px;
	}
	.address{
		font-size: 30px;
		color: #222;
	}
	.payBtn{
		text-align: right;
	}
	.orange {
		color: #ff6d02;
	}

	.noPayBar {
		margin: 10px 0px;
		height: 626px;
		background: #ffffff;
		text-align: center;
	}

	.noPayPC {
		height: 50%;
		margin-top: 15%;
		background: url("../Order/images/unfound_5.png") no-repeat center;
		background-size: 50% auto;
	}
</style>



// WEBPACK FOOTER //
// src/pages/evaluate/list.vue